import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { StorageService } from '../../services/storage.service';
import { objectKeys } from 'codelyzer/util/objectKeys';

@Component({
  selector: 'app-choose-project',
  templateUrl: './choose-project.component.html',
  styleUrls: ['./choose-project.component.scss']
})
export class ChooseProjectComponent implements OnInit {

  projects: any[] = [];
  project: any = null;
  backurl = '/';

  constructor(
    private dataService: DataService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private storage: StorageService
  ) {
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {

      if (params['backurl']) {
        this.backurl = params['backurl'];
      }

      this.dataService.getProjectList().subscribe((data) => {
        localStorage.setItem('user', JSON.stringify(data.user));
        combineLatest(data.projects.map(p => this.dataService.getProject(p.project_id).pipe(
          tap(project => {
            p.name = project.project_display_name;
          })
        ))).subscribe(result => {
          this.projects = result;
          this.project = this.projects[0];
        });
      });
    });

  }

  findParams(object, key) {
    let value;
    let that = this;
    Object.keys(object).some(function (k) {
      if (k === key) {
        value = object[k];
        return true;
      }
      if (object[k] && typeof object[k] === 'object') {
        value = that.findParams(object[k], key);
        return value !== undefined;
      }
    });
    return value;
  }

  chooseProject() {
    this.dataService.getProjectConfiguration(this.project.project_id).subscribe(result => {
      Object.keys(result.schema).map(key => {
        const subparams = this.findParams(result.schema[key], 'subparams');
        if (typeof subparams === 'object' && Object.values(subparams).length === 0) {
          delete result.schema[key];
        }
      });
      this.storage.set('project', Object.assign({ configuration: result }, this.project));
      this.dataService.project = null;
      this.router.navigateByUrl(this.backurl);
    });
  }

  cancel() {
    this.authService.logout();
    this.router.navigate(['login']);
  }
}
